document.addEventListener('DOMContentLoaded', function() {
  const categoryListSlider = new Swiper(".category-list-des-slider", {
      slidesPerView: 1.2,
      spaceBetween: 16,
      breakpoints: {
          480: {
              slidesPerView: 2,
              spaceBetween: 16,
          },
          768: {
              slidesPerView: 3,
              spaceBetween: 20,
          },
          990: {
              slidesPerView: 4,
              spaceBetween: 20,
          },
          1199: {
              slidesPerView: 5,
              spaceBetween: 20,
          },
          1400: {
              slidesPerView: 6,
              spaceBetween: 20,
          }
      },
      navigation: {
          nextEl: ".category-list-des .category-list-des-arrow.next",
          prevEl: ".category-list-des .category-list-des-arrow.prev",
      }
  });
});